import React from 'react';
import './Logo.css';

const Logo = ({ variant = 'default' }) => {
  return (
    <div className={`temple-logo ${variant}`}>
      <img
        src="/Assets/Logo3.png"
        alt="Shrinath Mhaskoba Mandir"
        className="temple-logo-image"
      />
    </div>
  );
};

export default Logo;
